import React, { useState, useEffect } from 'react';
import { sliderService } from '../api/sliderService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import SliderForm from '../components/Sliders/SliderForm';
import '../components/Common/Common.css';

function Sliders() {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editingSlider, setEditingSlider] = useState(null);

  const fetchSliders = async () => {
    try {
      setLoading(true);
      const response = await sliderService.getSliders({
        page: currentPage,
        per_page: 15,
      });
      setSliders(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching sliders:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSliders();
  }, [currentPage]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce slider ?')) {
      try {
        await sliderService.deleteSlider(id);
        fetchSliders();
      } catch (error) {
        console.error('Error deleting slider:', error);
        alert('Échec de la suppression du slider');
      }
    }
  };

  const handleEdit = (slider) => {
    setEditingSlider(slider);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingSlider(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingSlider(null);
    fetchSliders();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    {
      key: 'site',
      label: 'Site',
      render: (_, row) => (
        <span className={`badge ${row.site ? 'badge-info' : 'badge-secondary'}`}>
          {row.site ? row.site.name : 'Tech360'}
        </span>
      ),
    },
    { key: 'title', label: 'Titre', render: (val) => val || <span style={{ color: '#a0aec0', fontStyle: 'italic' }}>—</span> },
    {
      key: 'media_type',
      label: 'Type',
      render: (val) => (
        <span className={`badge ${val === 'video' ? 'badge-info' : 'badge-secondary'}`}>
          {val === 'video' ? 'Vidéo' : 'Image'}
        </span>
      ),
    },
    {
      key: 'id',
      label: 'Aperçu',
      render: (_, row) => {
        if (row.media_type === 'video' && row.video_url) {
          return (
            <video
              src={row.video_url}
              muted
              style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '4px', display: 'block' }}
            />
          );
        }
        if (row.image_url) {
          return (
            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
              <img src={row.image_url} alt="Desktop" style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '4px' }} title="Desktop" />
              {row.mobile_image_url && (
                <img src={row.mobile_image_url} alt="Mobile" style={{ width: '30px', height: '40px', objectFit: 'cover', borderRadius: '4px', opacity: 0.8 }} title="Mobile" />
              )}
            </div>
          );
        }
        return <span style={{ color: '#a0aec0' }}>—</span>;
      },
    },
    { key: 'position', label: 'Position' },
    {
      key: 'is_active',
      label: 'Statut',
      render: (val) => <span className={`badge ${val ? 'badge-success' : 'badge-danger'}`}>{val ? 'Actif' : 'Inactif'}</span>,
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Sliders</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter un slider
        </button>
      </div>

      <Table
        columns={columns}
        data={sliders}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editingSlider ? 'Modifier le slider' : 'Ajouter un slider'}
      >
        <SliderForm
          slider={editingSlider}
          onSuccess={handleFormSuccess}
          onCancel={() => setShowModal(false)}
        />
      </Modal>
    </div>
  );
}

export default Sliders;
